import { getBackendUrl } from "../config";

const isAbsoluteUrl = value => /^https?:\/\//i.test(value || "");

const resolveMessageMediaUrl = (mediaUrl, companyId) => {
  if (!mediaUrl) return "";

  if (isAbsoluteUrl(mediaUrl)) return mediaUrl;

  let backendUrl = getBackendUrl();
  if (!backendUrl && typeof window !== "undefined") {
    backendUrl = window.location.origin;
  }

  if (!backendUrl) return "";

  const trimmed = mediaUrl.replace(/^\/+/, "");

  if (trimmed.startsWith("public/")) {
    return `${backendUrl}/${trimmed}`;
  }

  if (companyId) {
    if (trimmed.startsWith(`company${companyId}/`)) {
      return `${backendUrl}/public/${trimmed}`;
    }
    return `${backendUrl}/public/company${companyId}/${trimmed}`;
  }

  return `${backendUrl}/${trimmed}`;
};

export default resolveMessageMediaUrl;
